export default __webpack_public_path__ + "static/illustration-gh-workflow-8d17f00f30bb3a771aaf6b53fede2c0f.svg";